import React, { useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import css from './SectionMetrics.module.css';



const SectionMetrics = props => {

  const { rootClassName, className, data, narrowTitle } = props;

  const classes = classNames(rootClassName || css.root, className);

  const blockItems = data.map((item, index) => {
    return <li key={index} className={css.itemHolder}>
      <div className={css.itemImageHolder}>
        <img className={css.itemImage} src={item.img} alt={item.title} />
      </div>
      <h4 className={css.itemTitle}>{item.title}</h4>
    </li>
  })

  return (
    <div className={classes}>
      <div className={css.blockHolder}>
        <ul className={css.itemsList}>{blockItems}</ul>
      </div>
    </div>
  );
};

SectionMetrics.defaultProps = { rootClassName: null, className: null };

SectionMetrics.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionMetrics;
